import {Component, Inject} from '@angular/core';
import {LoadingOrdersService} from '../../services/loading-orders.service';
import {MAT_DIALOG_DATA} from '@angular/material';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {SimpleConfirmActionDialogComponent} from '../simple-confirm-action-dialog/simple-confirm-action-dialog.component';
import {ToastMessagesService} from '../../services/toast-messages.service';

interface CheckResponse {
  code: number;
  message: string;
}

@Component({
  templateUrl: './edit-loading-order-serial-number.component.html'
})
export class EditLoadingOrderSerialNumberComponent {
  title: string;
  newSerialNumber: string;
  validSerialNumber: boolean;
  details: any;
  isLoading: boolean;
  isUpdating: boolean;
  checkResponse: CheckResponse;
  proceed: boolean;

  constructor(private loadingOrdersService: LoadingOrdersService,
              private matDialog: MatDialog,
              private matDialogRef: MatDialogRef<EditLoadingOrderSerialNumberComponent>,
              private toastMessagesService: ToastMessagesService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.title = data.title;
    this.validSerialNumber = false;
    this.details = data.details;
    this.isLoading = false;
    this.proceed = false;
    this.isUpdating = false;
  }

  close(value?) {
    this.matDialogRef.close(value);
  }

  async checkSerialNumber() {
    try {
      this.isLoading = true;
      if (this.details.serialNumber === this.newSerialNumber) {
        this.toastMessagesService.toastMessages('Προσπαθείτε να εισάγετε τον ίδιο σειριακό αριθμό.');
        return;
      }
      const model = {
        new_serial_number: this.newSerialNumber,
        id: this.details.rowId
      };

      this.checkResponse = await this.loadingOrdersService.checkSerialNumber(model) as CheckResponse;


      if (this.checkResponse.code === 1) {
        this.toastMessagesService.toastMessages(this.checkResponse.message);
        // this.close();
      }

      if (this.checkResponse.code === 2) {
        const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
          disableClose: true,
          data: {
            title: this.checkResponse.message,
            message: ''
          }
        });

        confirm.afterClosed().subscribe(result => {
          if (result) {
            this.proceed = true;
          } else {
            this.close();
          }
        });
      }

      if (this.checkResponse.code === 3) {
        this.proceed = true;
      }

    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isLoading = false;
    }
  }

  isDisabled() {
    if (this.isUpdating) {
      return true;
    } else {
      return !(this.proceed && (this.checkResponse.code === 2 || this.checkResponse.code === 3));
    }
  }

  async updateSerialNumber() {
    try {
      this.isUpdating = true;
      const model = {
        command_id: this.details.commandId,
        new_serial_number: this.newSerialNumber,
        loading_command_serial_number_details_id: this.details.rowId
      };
      await this.loadingOrdersService.updateSerialNumber(model);

      this.close(true);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isUpdating = false;
    }
  }
}
